import { render, staticRenderFns } from "./Terms&conditions.vue?vue&type=template&id=38db69cc&"
import script from "./Terms&conditions.vue?vue&type=script&lang=js&"
export * from "./Terms&conditions.vue?vue&type=script&lang=js&"
import style0 from "./Terms&conditions.vue?vue&type=style&index=0&id=38db69cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports